import { LoggerService } from '@ad-lucy/services/LoggerService';
import { useCallback, useEffect } from 'react';

import type { LiveRenderingReceiveMessage } from '../types';

const logger = LoggerService.getLogger().getModuleLogger(useReceiveMessage.name);

export function useReceiveMessage({
  callback,
}: {
  callback: (message: LiveRenderingReceiveMessage) => void;
}): void {
  const receiveMessage = useCallback(
    (event: MessageEvent<LiveRenderingReceiveMessage>) => {
      const { data } = event;
      if (event.origin.includes('factor-eleven.com') && data?.source === 'creator') {
        logger.info('Received message from creator:', data);
        callback(data);
      }
    },
    [callback],
  );

  useEffect(() => {
    window.addEventListener('message', receiveMessage);
    return () => window.removeEventListener('message', receiveMessage);
  }, [receiveMessage]);
}
